import { render, staticRenderFns } from "./dashboard-detail-list.vue?vue&type=template&id=62d93fc9&scoped=true&"
import script from "./dashboard-detail-list.vue?vue&type=script&lang=js&"
export * from "./dashboard-detail-list.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-detail-list.vue?vue&type=style&index=0&id=62d93fc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d93fc9",
  null
  
)

export default component.exports